<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title">
      {{ questionData?.name }}
    </h5>

    <div class="options-wrapper">
      <div class="option-row" v-for="(option, index) in questionData?.content?.options" :key="option.id">
        <div class="option" :class="{ 'image-option': hasImageOptions }">
          <ImageLoader
              v-if="option?.attachLeft?.file?.attachUrl"
              :source="option?.attachLeft?.file?.attachUrl"
              :style="{
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px',
                marginBottom: hasImageOptions ? '10px' : '0'
              }"
          />
          <input
              v-model="option.leftValue"
              @input="updateOption(index, 'leftValue', $event.target.value)"
              style="border: none; outline: none; background: transparent; font-size: 14px; color: #040C2D; font-family: euclid_regular, sans-serif; width: 100%;"
          />
        </div>

        <div class="option" :class="{ 'image-option': hasImageOptions }">
          <ImageLoader
              v-if="option?.attachRight?.file?.attachUrl"
              :source="option?.attachRight?.file?.attachUrl"
              :style="{
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px',
                marginBottom: hasImageOptions ? '10px' : '0'
              }"
          />
          <input
              v-model="option.rightValue"
              @input="updateOption(index, 'rightValue', $event.target.value)"
              style="border: none; outline: none; background: transparent; font-size: 14px; color: #040C2D; font-family: euclid_regular, sans-serif;"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";
import ImageLoader from "@/components/ImageLoader.vue";

export default{
  components: {QuestionImage, ImageLoader},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasImageOptions() {
      return this.questionData?.content?.options?.some(option =>
          option?.attachLeft?.file?.attachUrl || option?.attachRight?.file?.attachUrl
      ) || false;
    }
  },
  methods: {
    updateOption(optionIndex, field, value) {
      console.log('UPDATE:', optionIndex, field, value);
      if (this.questionData?.content?.options?.[optionIndex]) {
        this.questionData.content.options[optionIndex][field] = value;
        this.$emit('question-update', this.questionData);
      }
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
  z-index: 1;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.options-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
}

.option-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  max-width: 300px;
}

.option {
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 10px 10px;
  flex-shrink: 1;
  border: 2px solid transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
  max-width: 150px;
  overflow-x: hidden;
}

/* Image option styling */
.option.image-option {
  flex-direction: column;
  padding: 10px;
}

.option span {
  font-size: 14px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_regular, sans-serif;
}

/* Smaller text for image options */
.option.image-option span {
  font-size: 12px;
  text-align: center;
}
</style>
